// components/team_servicing/Header.jsx
// Team Servicing Dashboard Header using StandardHeader

import React from 'react';
import { StandardHeader } from '../../common/StandardHeader';

export const Header = ({ 
  loading, 
  lastUpdated,
  dateRange,
  onDateRangeChange,
  onRefresh,  // ✅ Accept onRefresh from parent
}) => {
  return (
    <StandardHeader
      title="Team Servicing"
      subtitle="Comprehensive analytics for team productivity and performance"
      loading={loading}
      lastUpdated={lastUpdated}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      onRefresh={onRefresh}  // ✅ Pass it directly to StandardHeader
      yearsOnly={false}
    />
  );
};